import React from "react";
import Button from "../../pages/ui/Button";

interface SuccessModalProps {
  isOpen: boolean;
  confirmText: string;
  onClose: () => void;
  title?: string;
  description?: string;
  onConfirm?: () => void;
}

const SuccessModal: React.FC<SuccessModalProps> = ({
  isOpen,
  onClose,
  title,
  description,
  confirmText,
  onConfirm,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white w-full max-w-md rounded-lg p-6 shadow-lg">
        {/* Icon Section */}
        <div className="flex justify-center mb-4">
          <div className="bg-green-100 text-green-500 rounded-full p-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className="w-8 h-8"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
        </div>

        {/* Title Section */}
        <h2 className="text-center text-xl font-semibold mb-2">{title}</h2>

        {/* Description Section */}
        <p className="text-center text-gray-600 mb-6">{description}</p>

        {/* Action Button */}
        <div className="flex justify-center">
          <Button
            onClick={() => {
              onConfirm?.();
              onClose();
            }}
            label={confirmText}
            layout="inline" minWidthClass="min-w-0"
          />
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
